// Mirrors the validation in functions/packages/*/submit/submit.js - this
// copy is only for instant UX feedback, the server-side copy is the real
// trust boundary and re-validates independently.
export const NAME_RE = /^[\p{L} .'-]{1,100}$/u;
export const PHONE_RE = /^\+?[0-9]{10,15}$/;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidName = (name) => NAME_RE.test(name.trim());
export const isValidPhone = (phone) => PHONE_RE.test(phone.trim());
export const isValidEmail = (email) => EMAIL_RE.test(email.trim());
